package com.example.mystybag.common.logic

import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.TextFieldValue
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.common.model.DualTextInputBSVisualModel
import com.example.mystybag.common.model.DualTextInputBottomSheetUIState

class DualTextInputBottomSheetViewModel(
    context                 : AppContext,
    private val visualModel : DualTextInputBSVisualModel
) : ChildViewModel<DualTextInputBottomSheetUIState>(
    context = context,
    uiData  = DualTextInputBottomSheetUIState(
        text1      = TextFieldValue(text = visualModel.initialText1, selection = TextRange(visualModel.initialText1.length)),
        text2      = TextFieldValue(text = visualModel.initialText2, selection = TextRange(visualModel.initialText2.length)),
        title      = visualModel.title,
        hint1      = visualModel.hint1,
        hint2      = visualModel.hint2,
        buttonText = visualModel.buttonText
    )
) {

    fun onText1Changed(value: TextFieldValue) {
        updateState { it.copy(text1 = value, isError = false) }
    }

    fun onText2Changed(value: TextFieldValue) {
        updateState { it.copy(text2 = value, isError = false) }
    }

    fun onButtonClicked() {
        val first  = uiState.value.text1.text
        val second = uiState.value.text2.text
        val validate = visualModel.validate?.invoke(first, second)
        if (validate?.first == true || (validate == null && first.isNotBlank() && second.isNotBlank()))
            visualModel.onTextChanged(first, second)
        else
            updateState {
                it.copy(
                    isError   = true,
                    errorText = validate?.second ?: it.errorText
                )
            }
    }
}
